/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../../Library';
import { Document } from '../../../core/models/Document';
import { IReferenceNode } from '../../../core/models/IReferenceNode';
import { Node } from '../../../core/models/Node';
import { IReferenceResolver } from '../../../core/util/IReferenceResolver';
import { ReferenceResolverChain } from '../../../core/util/ReferenceResolverChain';
import { VisitorUtil } from '../../../core/util/VisitorUtil';
import { TraverserDirection } from '../../../core/visitors/TraverserDirection';
import { DocumentType } from '../../../core/models/DocumentType';

/**
 * Setup the dereferencer execution.
 * 
 * @param {Document} source   original {@link Document}
 * @param {*} resolver provide a custom resolver, otherwise the common {@link io.apicurio.datamodels.core.util.ReferenceResolverChain}
 * is used.
 * @param {boolean} strict   If true, and there are any references that cannot be resolved, raise an exception.
 * Defaults to false.
 * @class
 * @author Jakub Senko <jsenko@redhat.com>
 */
export class Dereferencer {
    /*private*/ source : Document;

    /*private*/ resolver : IReferenceResolver;

    /*private*/ strict : boolean;

    /*private*/ unresolvable : Array<string>;

    public constructor(source? : any, resolver? : any, strict? : any) {
        if(((source != null && source instanceof <any>Document) || source === null) && ((resolver != null && (resolver["__interfaces"] != null && resolver["__interfaces"].indexOf("io.apicurio.datamodels.core.util.IReferenceResolver") >= 0 || resolver.constructor != null && resolver.constructor["__interfaces"] != null && resolver.constructor["__interfaces"].indexOf("io.apicurio.datamodels.core.util.IReferenceResolver") >= 0)) || resolver === null) && ((typeof strict === 'boolean') || strict === null)) {
            let __args = arguments;
            if(this.source===undefined) this.source = null;
            if(this.resolver===undefined) this.resolver = null;
            if(this.strict===undefined) this.strict = false;
            this.unresolvable = <any>([]);
            if(this.source===undefined) this.source = null;
            if(this.resolver===undefined) this.resolver = null;
            if(this.strict===undefined) this.strict = false;
            this.unresolvable = <any>([]);
            (() => {
                this.source = source;
                this.resolver = resolver;
                this.strict = strict;
            })();
        } else if(((source != null && source instanceof <any>Document) || source === null) && resolver === undefined && strict === undefined) {
            let __args = arguments;
            {
                let __args = arguments;
                let resolver : any = ReferenceResolverChain.getInstance();
                let strict : any = false;
                if(this.source===undefined) this.source = null;
                if(this.resolver===undefined) this.resolver = null;
                if(this.strict===undefined) this.strict = false;
                this.unresolvable = <any>([]);
                if(this.source===undefined) this.source = null;
                if(this.resolver===undefined) this.resolver = null;
                if(this.strict===undefined) this.strict = false;
                this.unresolvable = <any>([]);
                (() => {
                    this.source = source;
                    this.resolver = resolver;
                    this.strict = strict;
                })();
            }
        } else throw new Error('invalid overload');
    }

    /**
     * Execute the algorithm.
     * 
     * @return {Document} dereferenced clone of the source document.
     * @throws java.lang.RuntimeException if strict and some references could not be dereferenced
     */
    public dereference() : Document {
        let clone : Document = Library.cloneDocument(this.source);
        let strategy : IReferenceManipulationStrategy = null;
        switch((clone.getDocumentType())) {
        case DocumentType.asyncapi2:
            strategy = new Aai20IReferenceManipulationStrategy();
            break;
        case DocumentType.openapi2:
            strategy = new Oas20IReferenceManipulationStrategy();
            break;
        case DocumentType.openapi3:
            strategy = new Oas30IReferenceManipulationStrategy();
            break;
        default:
            throw Object.defineProperty(new Error("Unknown document type: " + clone.getDocumentType()), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
        }
        let processQueue : Array<Dereferencer.Context> = <any>([]);
        /* add */(processQueue.push(new Dereferencer.Context(this, null, clone))>0);
        let resolvedToLocalMap : any = <any>({});
        {
            let array180 = /* keySet */Object.keys(strategy.getExistingLocalComponents(clone));
            for(let index179=0; index179 < array180.length; index179++) {
                let ref = array180[index179];
                {
                    /* put */(resolvedToLocalMap[ref] = ref);
                }
            }
        }
        while((!/* isEmpty */(processQueue.length == 0))) {{
            let item : Dereferencer.Context = /* remove */processQueue.splice(0, 1)[0];
            let localComponents : any = strategy.getExistingLocalComponents(clone);
            let rcv : ReferenceCollectionVisitor = new ReferenceCollectionVisitor();
            VisitorUtil.visitTree(item.node, rcv, TraverserDirection.down);
            let referencedNodes : Array<IReferenceNode> = rcv.getReferencedNodes();
            for(let index181=0; index181 < referencedNodes.length; index181++) {
                let node = referencedNodes[index181];
                {
                    if(item.parentRef == null && /* containsKey */localComponents.hasOwnProperty(node.getReference())) continue;
                    let originalRef : Reference = new Reference(node.getReference());
                    let resolvedRef : Reference = originalRef;
                    if(item.parentRef != null && resolvedRef.isRelative()) {
                        resolvedRef = resolvedRef.withAbsoluteFrom(new Reference(item.parentRef));
                    }
                    if(/* containsKey */resolvedToLocalMap.hasOwnProperty(resolvedRef.getRef())) {
                        node.setReference(/* get */((m,k) => m[k]===undefined?null:m[k])(resolvedToLocalMap, resolvedRef.getRef()));
                        continue;
                    }
                    let resolved : Node = this.resolver.resolveRef(resolvedRef.getRef(), <Node><any>node);
                    if(resolved == null) {
                        /* add */((s, e) => { if(s.indexOf(e)==-1) { s.push(e); return true; } else { return false; } })(this.unresolvable, node.getReference());
                    } else {
                        let localRef : IReferenceManipulationStrategy.ReferenceAndNode = null;
                        let name : string = originalRef.getName();
                        for(let i : number = 0; i < 2147483647; i++) {{
                            if(i > 0) name = originalRef.getName() + i;
                            try {
                                localRef = strategy.attachAsDefinition(clone, name, resolved);
                                break;
                            } catch(ex) {
                            };
                        };}
                        if(localRef == null) {
                            /* add */((s, e) => { if(s.indexOf(e)==-1) { s.push(e); return true; } else { return false; } })(this.unresolvable, node.getReference());
                        } else {
                            node.setReference(localRef.getRef());
                            /* add */(processQueue.push(new Dereferencer.Context(this, originalRef.getRef(), localRef.getNode()))>0);
                            /* put */(resolvedToLocalMap[resolvedRef.getRef()] = localRef.getRef());
                        }
                    }
                }
            }
        }};
        if(/* size */(<number>this.unresolvable.length) !== 0 && this.strict) throw Object.defineProperty(new Error("Could not resolve some references: " + /* implicit toString */ (a => a?'['+a.join(', ')+']':'null')(this.unresolvable)), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
        return clone;
    }

    public getResolver() : IReferenceResolver {
        return this.resolver;
    }

    public isStrict() : boolean {
        return this.strict;
    }

    /**
     * After {@link #dereference()} is executed and strict is false,
     * 
     * @return {string[]} a possibly non-empty set of unresolved references
     */
    public getUnresolvableReferences() : Array<string> {
        return <any>(this.unresolvable.slice(0));
    }
}
Dereferencer["__class"] = "io.apicurio.datamodels.openapi.visitors.dereference.Dereferencer";


export namespace Dereferencer {

    /**
     * State for each recursive step
     * @class
     */
    export class Context {
        public __parent: any;
        parentRef : string;

        node : Node;

        constructor(__parent: any, parentRef : string, node : Node) {
            this.__parent = __parent;
            if(this.parentRef===undefined) this.parentRef = null;
            if(this.node===undefined) this.node = null;
            this.parentRef = parentRef;
            this.node = node;
        }

        /**
         * 
         * @param {*} o
         * @return {boolean}
         */
        public equals(o : any) : boolean {
            if(this === o) return true;
            if(o == null || (<any>this.constructor) !== (<any>o.constructor)) return false;
            let context : Dereferencer.Context = <Dereferencer.Context>o;
            if(this.parentRef != null?!/* equals */(<any>((o1: any, o2: any) => { if(o1 && o1.equals) { return o1.equals(o2); } else { return o1 === o2; } })(this.parentRef,context.parentRef)):context.parentRef != null) return false;
            return this.node != null?/* equals */(<any>((o1: any, o2: any) => { if(o1 && o1.equals) { return o1.equals(o2); } else { return o1 === o2; } })(this.node,context.node)):context.node == null;
        }

        /**
         * 
         * @return {number}
         */
        public hashCode() : number {
            let result : number = this.parentRef != null?/* hashCode */(<any>((o: any) => { if(o.hashCode) { return o.hashCode(); } else { return o.toString().split('').reduce((prevHash, currVal) => (((prevHash << 5) - prevHash) + currVal.charCodeAt(0))|0, 0); }})(this.parentRef)):0;
            result = 31 * result + (this.node != null?/* hashCode */(<any>((o: any) => { if(o.hashCode) { return o.hashCode(); } else { return o.toString().split('').reduce((prevHash, currVal) => (((prevHash << 5) - prevHash) + currVal.charCodeAt(0))|0, 0); }})(this.node)):0);
            return result;
        }
    }
    Context["__class"] = "io.apicurio.datamodels.openapi.visitors.dereference.Dereferencer.Context";

}




import { Reference } from './Reference';


import { ReferenceCollectionVisitor } from './ReferenceCollectionVisitor';


import { Oas30IReferenceManipulationStrategy } from './Oas30IReferenceManipulationStrategy';


import { Oas20IReferenceManipulationStrategy } from './Oas20IReferenceManipulationStrategy';


import { Aai20IReferenceManipulationStrategy } from './Aai20IReferenceManipulationStrategy';


import { IReferenceManipulationStrategy } from './IReferenceManipulationStrategy';

